/* eslint-disable import/no-extraneous-dependencies */
import React, { Suspense } from 'react';
import { Container } from '@mui/material';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';

import { Error5xx } from 'components/error/Error5xx';
import { MobileView } from 'layout/mobile/MobileView';
import { NavigationBar } from 'layout/navigation/NavigationBar';
import { isMobileBrowser, isTouchEnabled } from 'modules/device';

import { AppFeatures } from 'types/app';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/react-router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

const isMobileDevice = isMobileBrowser() && isTouchEnabled();

const RootComponent = () => (
  <Sentry.ErrorBoundary fallback={<Error5xx />} showDialog>
    <Container id="app-container">
      {isMobileDevice ? (
        <div className="mobile-view">
          <div id="app-content-mobile">
            <MobileView />
          </div>
        </div>
      ) : (
        <div className="normal-view">
          <div id="app-navigation">
            <NavigationBar />
          </div>
          <div id="app-content">
            <Outlet />
          </div>
        </div>
      )}
      <Suspense>
        <TanStackRouterDevtools position="bottom-left" />
      </Suspense>
    </Container>
  </Sentry.ErrorBoundary>
);

interface RouterContext {
  appFeatures: AppFeatures;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
